module.exports = __webpack_public_path__ + "img/dis.a9ee3aff.svg";